import React, { useCallback, useMemo } from 'react';
import { RCPWithQueryParams } from 'util/routing';
import { Enum, Filter } from 'util/backendapi/models/api.interfaces';
import { useReportState } from 'hooks/use-report-state';
import {
  PerformanceIndicatorListView,
  performanceIndicatorListColumns,
  PerformanceIndicatorListFilters,
} from './PerformanceIndicatorListView';
import { performanceIndicatorListDuck } from 'ducks/performance-indicator/list';
import { EMPTY_FUNC } from 'util/misc';
import { patchApi } from 'util/backendapi/fetch';

type OwnProps = RCPWithQueryParams<Filter.ReportsSites>;

export const PerformanceIndicatorListScreen = (ownProps: OwnProps) => {
  const columns = useMemo(() => {
    return performanceIndicatorListColumns({
      refreshList: EMPTY_FUNC,
      retirePerformanceIndicator: EMPTY_FUNC,
    });
  }, []);

  const retirePerformanceIndicator = useCallback(async (id: number) => {
    return patchApi(`/performance-indicators/${id}/`, {
      status: Enum.PerformanceIndicator_STATUS.retired,
    });
  }, []);

  const props = {
    reportProps: useReportState(
      ownProps,
      columns,
      PerformanceIndicatorListFilters,
      performanceIndicatorListDuck,
      (state) => state.performanceIndicator.list
    ),
    retirePerformanceIndicator,
  };

  return <PerformanceIndicatorListView {...props} />;
};
